export const IMAGES = [
  
  { src: "https://i.ibb.co/DKWf2Bk/image2.png", thumbnail: "" },
  { src: "https://i.ibb.co/pvhvpD4/image3.png", thumbnail: "" },
  { src: "https://i.ibb.co/D8LWBkJ/image4.png", thumbnail: "" },
  { src: "https://i.ibb.co/4R0ywxw/image5.png", thumbnail: "" },
  { src: "https://i.ibb.co/0GwwynC/image6.jpg", thumbnail: "" },
  { src: "https://i.ibb.co/z6RcQtW/image1.png", thumbnail: "" },
];
